
//Core
import 'Core/main';

//Iframe SCSS
import 'scss/IframeIso/app.scss';

//Vte Tools
import "vteTools/precarity-select"
import "vteTools/tooltipsVte"